import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router' 
import i18n from './lang'
import { Toast } from 'vant';
// 全局挂载组件
import components from '@/components'
Vue.use(Vant);
Vue.use(components)
Vue.use(Toast);
Vue.prototype.$timeCountdown = function (item) {
  const targetTime = item * 1000;
  const now = Date.now();
  const diff = targetTime - now;
  if (diff <= 0) return "00:00:00";

  const diffSeconds = Math.floor(diff / 1000);
  const days = Math.floor(diffSeconds / (3600 * 24));
  const hours = days * 24 + Math.floor((diffSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((diffSeconds % 3600) / 60);
  const seconds = diffSeconds % 60;

  const hh = String(hours).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');

  return `${hh}:${mm}:${ss}`;
};

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
